var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "181px",
    height: "3px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    x1: -0.0052235383884283604,
    y1: 2.998102790941748,
    x2: 130.9943079707791,
    y2: 2.998102790941749,
    id: "LinearGradient166"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "Stop167",
    stopColor: "#ffc20e",
    offset: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    id: "Stop168",
    stopColor: "#f3b511",
    offset: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    id: "Stop169",
    stopColor: "#db9b13",
    offset: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    id: "Stop170",
    stopColor: "#c48312",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -130 -41 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 126.23550295238653 0  L 181 3  L 4.748671035136073 3  L 0 0  L 126.23550295238653 0  Z ",
    fillRule: "nonzero",
    fill: "url(#LinearGradient166)",
    stroke: "none",
    transform: "matrix(1 0 0 1 130 41 )"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.d90a44b6fcf6d3e4353706013990aa5e.svg";
export { ForwardRef as ReactComponent };